import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-ghost-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading text-background-50 whitespace-nowrap">
                妖精动漫
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-md">
              妖精动漫汇集韩漫、日漫、国漫大全，韩国漫画、日本漫画、国产漫画免费全集在线阅读。下拉式流畅翻页，好看漫画追更不停。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速导航</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">热门分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/hanman" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline">韩漫</Link></li>
              <li><Link to="/category/riman" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline">日漫</Link></li>
              <li><Link to="/category/guoman" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline">国漫</Link></li>
              <li><Link to="/category/rexue" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline">热血</Link></li>
              <li><Link to="/category/aiqing" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline">爱情</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 妖精动漫 yaoyingdongman.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors no-underline">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors no-underline">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors no-underline">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}